
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { CardDescription, CardTitle } from "@/components/ui/card";

interface ClientesHeaderProps {
  clienteCount: number;
  isAdmin: boolean;
  onExport: () => void;
}

const ClientesHeader = ({ clienteCount, isAdmin, onExport }: ClientesHeaderProps) => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <CardTitle>Lista de Clientes</CardTitle>
        <CardDescription>
          Total de {clienteCount} clientes {!isAdmin && "seus "}cadastrados
        </CardDescription>
      </div>
      <Button 
        variant="outline" 
        className="text-energy-blue-dark border-energy-blue-dark hover:bg-energy-blue/10"
        onClick={onExport}
        disabled={clienteCount === 0}
      >
        <Download className="mr-2 h-4 w-4" />
        Exportar
      </Button>
    </div>
  );
};

export default ClientesHeader;
